module.exports = __webpack_public_path__ + "img/Button_Stop.d5619fa7.png";